import SemanticArticle from "./SemanticArticle";
export default SemanticArticle;